<template>
  <div class="resident-manage app-region blank-l-h blank-r-h">
    <a-row :gutter="64" type="flex">
      <a-col :span="24" :xl="6" class="divide">
        <a-tabs :default-active-key="tabActive" @change="changeTab" :animated="false">
          <a-tab-pane key="1" tab="房源架构">
            <a-input placeholder="请输入关键词" v-model="tree.keyword" @change="filterKeyword(tree.data, 'tree.searchData', tree.keyword, tree.params.title, tree.params.children)"></a-input>
            <a-spin tip="加载中..." :spinning="tree.loading">
              <a-tree block-node :tree-data="tree.keyword ? tree.searchData : tree.data" :replaceFields="tree.params" @select="selectTreeNode" :selected-keys="tree.selectedKeys" :load-data="$houseTreeData"></a-tree>
            </a-spin>
          </a-tab-pane>
          <a-tab-pane key="2" tab="住户标签">
            <a-row :gutter="16" type="flex" align="middle">
              <a-col flex="1">
                <a-input placeholder="请输入关键词" v-model="labelTree.keyword" @change="filterKeyword(labelTree.data, 'labelTree.searchData', labelTree.keyword, labelTree.params.title, labelTree.params.children)"></a-input>
              </a-col>
              <a-col v-if="isPlatformRole">
                <a-icon type="plus" class="add-label" @click="addLabel"></a-icon>
              </a-col>
            </a-row>
            <a-spin tip="加载中..." :spinning="labelTree.loading">
              <a-tree class="list" block-node :tree-data="labelTree.keyword ? labelTree.searchData : labelTree.data" :replaceFields="labelTree.params" @select="selectLabelTreeNode" :selected-keys="labelTree.selectedKeys">
                <template slot="title" slot-scope="row">
                  <a-row type="flex">
                    <a-col flex="1">{{row[labelTree.params.title]}}</a-col>
                    <a-col v-if="isPlatformRole">
                      <a-dropdown>
                        <a-icon type="ellipsis"></a-icon>
                        <a-menu slot="overlay">
                          <a-menu-item @click="editLabel(row)">编辑</a-menu-item>
                          <a-menu-item @click="deleteLabel(row)">删除</a-menu-item>
                        </a-menu>
                      </a-dropdown>
                    </a-col>
                  </a-row>
                </template>
              </a-tree>
            </a-spin>
          </a-tab-pane>
        </a-tabs>
      </a-col>
      <a-col :span="24" :xl="18">
        <div class="page-title">{{name}}（{{total}}）</div>
        <resident-list :id="id" :community-id="communityId" @total="setTotal" v-if="tabActive === '1'" ></resident-list>
        <label-list :id="labelTree.selectedKeys[0]" @total="setTotal" v-else></label-list>
      </a-col>
    </a-row>
    <!-- 新增标签 -->
    <a-modal :title="addLabelModal.title" :confirm-loading="addLabelModal.loading" v-model="addLabelModal.show" @ok="confirmAddLabelModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="标签名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入标签名称" allow-clear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 编辑标签 -->
    <a-modal :title="editLabelModal.title" :confirm-loading="editLabelModal.loading" v-model="editLabelModal.show" @ok="confirmEditLabelModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="标签名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入标签名称" allow-clear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import LabelService from '@/io/label.js';
  import ResidentList from '@/views/community/resident/List.vue';
  import LabelList from '@/views/community/label/List.vue';

  export default {
    name: 'ResidentManage',
    data() {
      return {
        tabActive: '1',
        tree: {
          selectedKeys: [],
          keyword: null,
          loading: false,
          data: [],
          searchData: [],
          params: {
            children: 'children',
            title: 'name',
            key: '_id'
          }
        },
        labelTree: {
          selectedKeys: [],
          keyword: null,
          loading: false,
          data: [],
          searchData: [],
          params: {
            children: 'children',
            title: 'name',
            key: 'id'
          }
        },
        id: null,
        communityId: null,
        name: null,
        total: null,
        form: {
          name: null,
        },
        rules: {
          name: [
            {
              required: true,
              message: '请填写标签名称'
            }
          ]
        },
        addLabelModal: {
          id: null,
          title: '新增标签',
          show: false,
          loading: false
        },
        editLabelModal: {
          id: null,
          title: '编辑标签',
          show: false,
          loading: false
        }
      }
    },
    mounted () {
      this.initTreeData().then(() => {
        this.selectTreeNode([this.tree.data[0][this.tree.params.key]]);
      });
      this.initLabelTreeData();
    },
    components: {
      ResidentList,
      LabelList
    },
    methods: {
      changeTab(key) {
        this.tabActive = key;
        if (this.tabActive === '2' && !this.labelTree.selectedKeys.length) {
          this.selectLabelTreeNode([this.labelTree.data[0][this.labelTree.params.key]]);
        }
        this.setName();
      },
      selectLabelTreeNode(selectedKeys) {
        if (selectedKeys.length) {
          this.labelTree.selectedKeys = selectedKeys;
          this.setName();
        }
      },
      setName() {
        let name = '全部';
        if (this.tabActive === '1') {
          this.$depthSearchTree(node => {
            if (node[this.tree.params.key] === this.tree.selectedKeys[0]) {
              name = node[this.tree.params.title];
            }
          }, this.tree.data);
        } else {
          name = this.labelTree.data.filter(val => val[this.labelTree.params.key] === this.labelTree.selectedKeys[0])[0][this.labelTree.params.title];
        }
        this.name = name;
      },
      selectTreeNode(selectedKeys) {
        if (selectedKeys.length) {
          this.tree.selectedKeys = selectedKeys;
          this.$depthSearchTree(node => {
            if (node[this.tree.params.key] === selectedKeys[0]) {
              if (node.level === 0) {
                this.id = null;
                this.communityId = node.id;
              } else {
                this.id = node.id;
                this.communityId = node.communityId;
              }
            }
          }, this.tree.data);
          this.setName();
        }
      },
      setTotal(total) {
        this.total = total;
      },
      initTreeData() {
        this.tree.loading = true;
        return this.$houseTreeData([], [this.isPlatformRole ? 0 : 1, 4]).then(res => {
          this.tree.data = res;
          this.tree.loading = false;
        });
      },
      initLabelTreeData() {
        this.labelTree.loading = true;
        return LabelService.list().then(res => {
          this.$depthSearchTree(node => {
            node.scopedSlots = {
              title: 'title'
            }
          }, res);
          this.labelTree.data = res;
        }).catch(err => {}).finally(() => {
          this.labelTree.loading = false;
        });
      },
      addLabel() {
        this.form.name = null;
        this.addLabelModal.show = true;
      },
      editLabel(data) {
        this.form.name = data[this.tree.params.title];
        this.editLabelModal.id = data[this.labelTree.params.key];
        this.editLabelModal.show = true;
      },
      deleteLabel(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此标签？',
          onOk() {
            LabelService.del(data[self.labelTree.params.key]).then(res => {
              self.initLabelTreeData();
            }).catch(err => {});
          }
        });
      },
      confirmAddLabelModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.addLabelModal.loading = true;
          LabelService.add(this.form.name).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.initLabelTreeData();
            });
          }).catch(err => {}).finally(() => {
            this.addLabelModal.show = false;
            this.addLabelModal.loading = false;
          });
        });
      },
      confirmEditLabelModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.editLabelModal.loading = true;
          LabelService.edit(this.editLabelModal.id, this.form.name).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.initLabelTreeData();
            });
          }).catch(err => {}).finally(() => {
            this.editLabelModal.show = false;
            this.editLabelModal.loading = false;
          });
        });
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .resident-manage {
    .add-label {
      color: @primary-color;
      font-size: @font-size-lg;
      cursor: pointer;
    }
  }
  /deep/ .ant-tabs {
    .ant-tabs-bar {
      &.ant-tabs-top-bar {
        .ant-tabs-nav-container {
          .ant-tabs-nav-wrap {
            .ant-tabs-nav-scroll {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }
</style>